import React from 'react';

interface RegenerateIconProps {
  fontSize?: string;
  className?: string;
}

const RegenerateIcon: React.FC<RegenerateIconProps> = ({ 
  fontSize = '14px', 
  className = '' 
}) => (
  <span 
    className={`regenerateIcon ${className}`} 
    style={{ fontSize }}
  >
    ✨
  </span>
);

export default RegenerateIcon;

